import classNames from 'classnames';
import React, { type ReactNode } from 'react';
import styles from './Footer.module.sass';

interface FooterProps {
  children: ReactNode;
  status?: 'OPEN' | 'CLOSED';
  tokenExpired?: boolean;
  className?: string;
}
// Component
const Footer: React.FC<FooterProps> = ({ children, status, tokenExpired, className }) => {
  const footerClass = classNames(styles['footer'], className, {
    [styles['burgundy-background']]: status === 'OPEN' && !tokenExpired,
  });
  return <div className={footerClass}>{children}</div>;
};

export default Footer;
